//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
  headingText: {
    padding: 10,
    fontSize: 25,
    fontFamily: "segoe-ui",
    color: "#2F7CBD",
  },
  headingText2Grid: {
    padding: "20px 50px",
    "@media (max-width: 600px)": {
      padding: 0,
    },
  },
  headingText2: {
    paddingBottom: "1.25rem",
    fontSize: "1.125rem",
    fontFamily: "segoe-ui",
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  btnGrid: {
    padding: "0px 50px 26px 50px",
    fontSize: 20,
    alignSelf: "flex-end",
    textAlign: "end",
  },
  submitBtn: {
    // color: "#fff!important",
    // backgroundColor: "#2F7CBD",
    // fontSize: "22px!important",
    // border: " 1px solid #2F7CBD",
    // borderRadius: "10px!important",
    // width: 150,
    // height: 45,
    // textTransform: "capitalize!important",
    marginRight: 10,
    fontFamily: "segoe-ui!important",
    float: "right",
    "&:hover": {
      backgroundColor: "#2F7CBD!important",
      boxShadow: "none !important",
    },
  },
  searchInput: {
    width: "100%",
  },
  grid: {
    padding: "20px 0px 20px 50px",
    fontSize: 18,
  },
  headerDiv: {
    fontWeight: "bold",
    padding: 3,
  },
  editHead: {
    fontWeight: "bold",
  },
  orderSourceInput: {
    width: "30%",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  createGrid: {
    padding: 12,
  },
  resetBtn: {
    verticalAlign: "bottom",
    //marginLeft: 30,
    float: "right",
  },
  createInput: {
    width: "100%",
  },
  extendedInput: {
    // minWidth: "400px",
    width: "100%",
  },
  orgInput: {
    width: "100%",
  },
  siteInput: {
    width: "100%",
  },
  // table
  root: {
    width: "100%",
    marginTop: 50,
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableHeader: {
    background: "#EDEDED",
    boxShadow:
      "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  rowCell: {
    fontSize: "0.875rem",
    fontFamily: "segoe-ui",
    padding: "0px",
    borderBottom: "none",
    // width: "100px"
  },
  tableContainer: {
    overflow: "hidden",
    "@media (max-width: 768px)": {
      overflow: "auto",
    },
  },
  backArrowBtn: {
    padding: "0px 20px",
    verticalAlign: "bottom",
    "&:hover": {
      background: "none",
    },
  },
  addNewBtn: {
    border: "none",
    float: "right",
    backgroundColor: "#0a72ba",
    color: "#fff",
    width: "140px",
    borderRadius: "5px",
    marginTop: 5,
    cursor: "pointer",
    padding: "4px 8px",
  },
  labelName: {
    fontWeight: "bold",
    margin: "5px 0",
  },
  popupCancelBtn: {
    width: 110,
    padding: "4px 8px",
    backgroundColor: "#ededed",
    border: "none",
    borderRadius: 5,
    color: "#000",
    margin: 10,
    cursor: "pointer",
  },
  popupCancelBtn1: {
    width: 110,
    padding: "4px 8px",
    backgroundColor: "#0a72ba",
    border: "none",
    borderRadius: 5,
    color: "#fff",
    margin: 10,
    cursor: "pointer",
  },
  saveBtn: {
    width: 110,
    padding: "4px 8px",
    backgroundColor: "#0a72ba",
    border: "none",
    borderRadius: 5,
    color: "#fff",
    cursor: "pointer",
  },
  gridFive: {
    textAlign: "right",
    fontSize: 18,
    padding: 10,
  },
  dateInput: {
    //    minWidth: 400,
    width: "100%",
    marginTop: 22,
  },

  //view overwrite styles

  editBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 100,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  editCancelBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    fontSize: 15,
    border: " 1px solid #305698",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    margin: "5px 0px",
  },
  firstDiv: {
    width: "100%",
    height: 40,
    backgroundColor: "#E4E4E4",
    marginTop: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  secondDiv: {
    color: "#707070",
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginLeft: 10,
  },
  type: {
    color: "#707070",
    fontSize: "0.875rem",
    fontWeight: "bold",
    marginRight: 10,
    "@media (max-width: 768px)": {
      fontSize: 12,
    },
  },
  grid: {
    padding: 10,
    fontSize: "1rem",
    alignSelf: "center",
  },
  gridSpan: {
    fontWeight: "bold",
  },
  processed: {
    color: "green",
  },
  headingText2: {
    marginTop: 25,
    fontSize: "1.125rem",
    marginBottom: 10,
    fontFamily: "segoe-ui",
    "@media (max-width: 768px)": {
      padding: 10,
    },
  },
  tableGrid: {
    marginBottom: "150px",
  },
  RemoveRedEyeIcon: {
    cursor: "pointer",
  },
  gridContainer: {
    padding: 10,
  },
  gridItem: {
    textAlign: "right",
    position: "absolute",
    right: "5%",
    marginTop: "60px",
  },
  promotionalSpan: {
    fontWeight: "bold",
    verticalAlign: "Sub",
  },
  cssTextField: {
    width: 200,
  },
  exportParentDiv: {
    color: "#fff",
    cursor: "pointer",
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },

  exportBtn1: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    // marginLeft:"38%",

    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  // CSVlink: {
  //   display: "none",
  // },
}));
